var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('spinner',{staticClass:"mt-5"}):_c('div',_vm._l((_vm.program.offers),function(offer,index){return _c('OfferSheet',{key:index,staticClass:"offer-sheet__item",attrs:{"offer":offer,"offer-index":index}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }